import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import SubdirectionsContainer from 'app/containers/SubdirectionsContainer';
import TextEvents from 'app/components/TextEvents';
import { Select, Button, DatePicker, Tooltip, Icon } from 'antd';
import isEmpty from 'app/utils/IsEmpty';

import ApiService from 'app/services/ApiService';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBookmark, clearBookmark } from 'app/actions/BookmarkActions';
import moment from 'moment';

const { Option } = Select;

const SelectItem = (name = [], value) => {
    if(name == null){
        name = []
    }
    let x =name[value]
    return typeof name !== 'undefined' && name !== null  ? name.map((c, i) => <Option key={i}>{c}</Option>) : (name === null ? <Option key={'cargando'}>No existen valores..</Option> : <Option disabled key={'cargando'}>Cargando valores..</Option>);
}

export default function BookmarksForm(props) {
    const classes = props.classes;
    const styles= props.styles
    const dispatch = useDispatch();
    const [collapse, setCollapse] = useState(true);
    let [employee, setEmployeename] = useState('');
    const [front, setFront] = useState('');
    const [id, setId] = useState('');
    const [contract, setContract] = useState('');
    const [work, setWork] = useState('');
    const [filter, setFilter] = useState({});
    const [creationDateI, setCreationDateI] = useState('');
    const [creationDateF, setCreationDateF] = useState('');
    const [cp, setCP] = useState('');
    const {siteId} = useSelector(state => state.Auth)
    let contractList=[];
    let frontList=[];
    let employeeList=[];
    let CPList=[];
    let OTList=[];

    const data = {
        Subdirection:'3',
        BookMarkFolio: id.toString(),
        EmployeeId: employee,
        Contract: contract,
        Work: work,
        Front: front,
        CommunicationProgram: cp,
        StartDateCreation: creationDateI,
        EndDateCreation: creationDateF,
        sortColumn: Object.keys(props.sorter).length > 0 ? props.sorter.field : '',
        sortDir: Object.keys(props.sorter).length > 0 ? props.sorter.order === "ascend" ? "ASC" : "DESC" : '',
        offset: (0 * props.pagination.pageSize),
        limit: props.pagination.pageSize
    }

    useEffect(()=>{
        if(!isEmpty(props.bookmarksFilters)){
            setFilter(props.bookmarksFilters)
            props.setFilter(props.bookmarksFilters)
        }
    })

    const search = () => {
        dispatch(clearBookmark());
        dispatch(fetchBookmark(data));
        props.setFormData(data);
    }

    const toExport = async () => {
        await ApiService.exportBookmarks(data)
            .then(
                result => {
                    const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    downloadFile(blob, "Bookmarks.xlsx");
                },
                error => {
                    // eslint-disable-next-line no-throw-literal
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    }

    const downloadFile = (blob, fileName) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.append(link);
        link.click();
        link.remove();
        window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
    };
    
    const SelectWorkItem = (name = [], value) => {
        if(name == null){
            name = []
        }
        OTList.push(name);
        let x = [...new Set(name.map(i => i[value]))];
        x = name.map(i => i[value]);
        return (
            x.map((c, i) => <Option key={i}>{c}</Option>)
        );
    }
    const SelectFilterItem = (name = [], value) => {
        if(name == null){
            name = []
        }
        frontList.push(name)
        let x = [...new Set(name.map(i => i[value]))];
        x = name.map(i => i[value]);
        return (
            x.map((c, i) => <Option key={i}>{c}</Option>)
        );
    }
    const SelectCPItem = (name = [], value) => {
        if(name == null){
            name = []
        }
        CPList.push(name)
        let x = [...new Set(name.map(i => i[value]))];
        x = name.map(i => i[value]);
        return (
            x.map((c, i) => <Option key={i}>{c}</Option>)
        );
    }
    const SelectEmployeeItem = (name = [], value) => {
        if(name == null){
            name = []
        }
        employeeList.push(name)
        let x = [...new Set(name.map(i => i[value]))];
        x = name.map(i => i[value]);
        return (
            x.map((c, i) => {
                return (<Option key={i}>{c}</Option>)})
        );
    }
    const SelectContractItem = (name = [], value) => {

        if(name == null){
            name = []
        }
        contractList.push(name);
        let x = [...new Set(name.map(i => i[value]))];
        x = name.map(i => i[value]);
        return (
            x.map((c, i) => <Option key={i}>{c}</Option>)
        );
    }

    const handleChange = (value, i, key) => {
        const array = [];
        i.map(i => {
            array.push(i.props.children);
            return array;
        })
        if (i.length === 0) {
            switch (key) {
                case 'cpFolio':
                    setId('')
                    break;
                case 'contractName':
                    setContract('')
                    break;
                case 'communicationProgramName':
                    setCP('')
                    break;
                case 'ot':
                    setWork('')
                    break;
                case 'name':
                    setEmployeename('')
                    break;
                case 'frontName':
                    setFront('')
                    break;
                default:
                    break;
            }
        }
        // eslint-disable-next-line array-callback-return
        i.map(() => {
            if (key === 'cpFolio') {
                setId(array.join('|'));
            } else if (key === 'frontName') {
                let newFrontList = [];
                array.map(i => {
                    // eslint-disable-next-line array-callback-return
                    return frontList[0].map(ids => {
                        if (ids.frontName === i) {
                            const res = ids['idFront'];
                            newFrontList.push(res);
                        }
                    })
                })
                setFront(newFrontList.join('|'))
            }else if (key === 'contractName') {
                let newContractList = [];
                array.map(i => {
                    // eslint-disable-next-line array-callback-return
                    return contractList[0].map(ids => {
                        if (ids.contractName === i) {
                            const res = ids['idContract'];
                            newContractList.push(res);
                        }
                    })
                })
                setContract(newContractList.join('|'))
            }else if (key === 'communicationProgramName') {
                let newCPList = [];
                array.map(i => {
                    // eslint-disable-next-line array-callback-return
                    return CPList[0].map(ids => {
                        if (ids.communicationProgramName === i) {
                            const res = ids['idCommunicationProgram'];
                            newCPList.push(res);
                        }
                    })
                })
                setCP(newCPList.join('|'))
            }
            else if (key === 'ot') {
                let newOTList = [];
                array.map(i => {
                    // eslint-disable-next-line array-callback-return
                    return OTList[0].map(ids => {
                        if (ids.workName === i) {
                            const res = ids['idWork'];
                            newOTList.push(res);
                        }
                    })
                })
                setWork(newOTList.join('|'))
            }
            else if (key === 'name') {
                let newEmployeeList = [];
                array.map(i => {
                    // eslint-disable-next-line array-callback-return
                    return employeeList[0].map(ids => {
                        if (ids.name === i) {
                            const res = ids['employeeId'];
                            newEmployeeList.push(res);
                        }
                    })
                })
                setEmployeename(newEmployeeList.join('|'))
            }

        })
    }

    const disabledStartDate = (current) => {
        if (creationDateF === "") {
          return false;
        } else {
          if (moment(current.format('YYYY-MM-DD')) > moment(creationDateF)) {
            return true;
          } else return false;
        }
      }
      const disabledEndDate = (current) => {
        if (creationDateI === "") {
          return false;
        } else {
          if (moment(current.format('YYYY-MM-DD')) < moment(creationDateI)) {
            return true;
          } else return false;
        }
      }



    return (
        <div>
            <div hidden={collapse}>
            <Grid container direction="row">
                <Grid item xs={6}>
                    <TextEvents
                        text='Subdirección'
                        color='darker'
                        size='label'
                        weight='medium'
                    />
                    <SubdirectionsContainer>
                        {(params) => {
                            const defaultParam=params.subdirs.filter(i=> i.idSubdirection===3);
                            return (                                          
                                <Select
                                    labelInValue
                                    defaultValue={{ key: '3'}}
                                    disabled
                                    style={styles.inputSelect}
                                >
                                    {defaultParam.map((item) => {
                                            return (
                                                <Select.Option key={String(item.idSubdirection)} value={String(item.idSubdirection)}>
                                                    {item.subdirectionName}
                                                </Select.Option>
                                            )
                                        })
                                    }
                                </Select>
                            )
                    }}
                </SubdirectionsContainer>
                </Grid>
                <Grid item xs={6}>
                    <TextEvents
                        text='Contrato'
                        color='darker'
                        size='label'
                        weight='medium'
                    />
                      <Select
                        showSearch
                        optionFilterProp="children"
                        mode='multiple'
                        style={styles.inputSelect}
                        placeholder='Selecciona contrato'
                        onChange={(v, i) => handleChange(v, i, 'contractName')}
                        >
                            {filter.contract!==undefined ? SelectContractItem(filter.contract, 'contractName'):[]}
                        </Select>
                </Grid>
            </Grid>
            <Grid container direction="row">
                <Grid item xs={6}>
                    <TextEvents
                        text='OT'
                        color='darker'
                        size='label'
                        weight='medium'
                    />
                    <Select
                        mode='multiple'
                        showSearch
                        optionFilterProp="children"
                        style={styles.inputSelect}
                        placeholder='Selecciona OT'
                        onChange={(v, i) => handleChange(v, i, 'ot')}
                    >
                        {SelectWorkItem(filter.work===undefined?[]:filter.work, 'workName')}
                    </Select>
                </Grid>
                
                <Grid item xs={6}>
                    <TextEvents
                            text='Programa de comunicación'
                            color='darker'
                            size='label'
                            weight='medium'
                        />
                    <Select
                        showSearch
                        optionFilterProp="children"
                        mode='multiple'
                        style={styles.inputSelect}
                        placeholder='Selecciona programa de comunicación'
                        onChange={(v, i) => handleChange(v, i, 'communicationProgramName')}
                    >
                        {SelectCPItem(filter.communicationProgram===undefined?[]:filter.communicationProgram, 'communicationProgramName')}
                    </Select>
                </Grid>
            </Grid>
            <Grid container direction='row'>
                <Grid item xs={6}>
                    <TextEvents
                        text='Frente'
                        color='darker'
                        size='label'
                        weight='medium'
                    />
                    <Select
                        showSearch
                        optionFilterProp="children"
                        mode='multiple'
                        style={styles.inputSelect}
                        placeholder='Selecciona frente'
                        onChange={(v, i) => handleChange(v, i, 'frontName')}
                    > 
                        {SelectFilterItem(filter.front===undefined?[]:filter.front, 'frontName')}
                    </Select>
                </Grid>
                <Grid item xs={6}>
                    <TextEvents
                        text='Folio'
                        color='darker'
                        size='label'
                        weight='medium'
                    />
                    <Select
                        mode="multiple"
                        showSearch
                        optionFilterProp="children"
                        style={styles.inputSelect}
                        placeholder="Selecciona folio"
                        onChange={(v, i) => handleChange(v, i, 'cpFolio')}
                    >
                        {SelectItem(filter.folio===undefined?[]:filter.folio, 'cpFolio')}
                    </Select>
                </Grid>
                </Grid>
            <Grid container direction="row">
                <Grid item xs={12} md={6}>
                    <TextEvents
                        text='Creado por'
                        color='darker'
                        size='label'
                        weight='medium'
                    />
                    <Select
                        mode="multiple"
                        showSearch
                        optionFilterProp="children"
                        style={styles.inputSelect}
                        placeholder="Selecciona nombre"
                        onChange={(v, i) => handleChange(v, i, 'name')}
                    >
                        {SelectEmployeeItem(filter.employee===undefined?[]:filter.employee, 'name')}
                    </Select>
                </Grid>
                <Grid item xs={12} md={6}>
                        <TextEvents
                            text='Fecha de Creación:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <TextEvents
                            text='Desde:'
                            color="gray"
                            size='tiny'
                            weight="light"
                            styleDisplay='initial'
                            styleMargin='2px'
                        />
                        <DatePicker
                            style={{width:'40%'}}
                            format={'DD/MM/YYYY'}
                            disabledDate={disabledStartDate}
                            onChange={(date, dateString) => {
                                setCreationDateI(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                            }}

                        /> <TextEvents
                            text='Hasta:'
                            color="gray"
                            size='tiny'
                            weight="light"
                            styleDisplay='initial'
                            styleMargin='2px'
                        />
                        <DatePicker
                            style={{width:'40%'}}
                            format={'DD/MM/YYYY'}
                            disabledDate={disabledEndDate}
                            onChange={(date, dateString) => {
                                setCreationDateF(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                            }}
                        />
                    </Grid>
                </Grid>
            </div>
            <div className={classes.container} style={styles.baseVerticalMargin}>
            {
                  collapse ?
                    <Tooltip title={"Mostrar filtro"}>
                      <Button
                        className={classes.button}
                        variant="contained"
                        type="link"
                        onClick={() => setCollapse(false)}
                      >
                        <Icon type="down" />
                      </Button>
                    </Tooltip> :
                    <Tooltip title={"Ocultar filtro"}>
                      <Button
                        className={classes.button}
                        variant="contained"
                        type="link"
                        onClick={() => setCollapse(true)}
                      >
                        <Icon type="up" />
                      </Button>
                    </Tooltip>
                }
                <Button
                    className={classes.button}
                    variant="contained"
                    type="primary"
                    onClick={() => search()}
                >
                    Buscar
                    </Button>
                <Button
                    className={classes.button}
                    variant="contained"
                    type="primary"
                    onClick={toExport}
                >
                    Exportar
                </Button>
                    <Button
                        className={classes.button}
                        variant="contained"
                        type="primary"
                        onClick={() =>props.setVisible(true)}
                    >
                        Nuevo Bookmark
                    </Button>
            </div>
        </div>
    );

}